import {
  PRD_ETH_DEPOSIT_CONTRACT_ABI,
  PRD_ETH_PAXG_APPROVE_ABI,
  PRD_ETH_USDT_ERC20_APPROVE_ABI,
  PRD_ETH_WITHDRAW_ABI,
} from './eth-abi.prd';
import {
  STG_ETH_DEPOSIT_CONTRACT_ABI,
  STG_ETH_LOAN_DEPOSIT_CONTRACT_ABI,
  STG_ETH_PAXG_APPROVE_ABI,
  STG_ETH_USDT_ERC20_APPROVE_ABI,
  STG_ETH_WITHDRAW_ABI,
} from './eth-abi.stg';

const isStg = process.env.NEXT_PUBLIC_ENV === 'stg';

const ethDepositContractAbi = isStg
  ? STG_ETH_DEPOSIT_CONTRACT_ABI
  : PRD_ETH_DEPOSIT_CONTRACT_ABI;

const ethLoanDepositContractAbi = isStg
  ? STG_ETH_LOAN_DEPOSIT_CONTRACT_ABI
  : PRD_ETH_DEPOSIT_CONTRACT_ABI;

const paxgDepositApproveAbi = isStg
  ? STG_ETH_PAXG_APPROVE_ABI
  : PRD_ETH_PAXG_APPROVE_ABI;

const usdtERC20ApproveAbi = isStg
  ? STG_ETH_USDT_ERC20_APPROVE_ABI
  : PRD_ETH_USDT_ERC20_APPROVE_ABI;

const ethClaimAbi = isStg ? STG_ETH_WITHDRAW_ABI : PRD_ETH_WITHDRAW_ABI;

export {
  ethClaimAbi,
  ethDepositContractAbi,
  ethLoanDepositContractAbi,
  paxgDepositApproveAbi,
  usdtERC20ApproveAbi,
};
